// extracted by mini-css-extract-plugin
export default {"block":"responsiveCloudinary-module--block--3wQj4"};